import { IconMapType } from "./types";
import { Regular, Solid } from "./assets";

export const IconMap: Record<string, IconMapType> = {
  home: {
    name: "home",
    solidSvg: Solid.SolidHouseIcon,
    regularSvg: Regular.RegularHouseIcon
  },
  ellipsis: {
    name: "ellipsis",
    solidSvg: Solid.SolidEllipsisIcon,
    regularSvg: Regular.RegularEllipsisIcon
  },
  "badge-check": {
    name: "badge-check",
    solidSvg: Solid.SolidBadgeCheckIcon,
    regularSvg: Solid.SolidBadgeCheckIcon
  },
  "dollar-sign": {
    name: "circle-dollar-to-slot",
    solidSvg: Solid.SolidCircleDollarIcon,
    regularSvg: Regular.RegularCircleDollarIcon
  },
  "magnifying-glass-dollar": {
    name: "magnifying-glass-dollar",
    solidSvg: Solid.SolidMagnifyingGlassDollarIcon,
    regularSvg: Solid.SolidMagnifyingGlassDollarIcon
  },
  "chart-line": {
    name: "chart-line",
    solidSvg: Solid.SolidChartLineUpIcon,
    regularSvg: Regular.RegularChartLineUpIcon
  },
  "hand-holding-dollar": {
    name: "hand-holding-dollar",
    solidSvg: Solid.SolidHandHoldingDollarIcon,
    regularSvg: Regular.RegularHandHoldingDollarIcon
  },
  "file-pen": {
    name: "file-pen",
    solidSvg: Solid.SolidFilePenIcon,
    regularSvg: Regular.RegularFilePenIcon
  },
  "circle-user": {
    name: "circle-user",
    solidSvg: Solid.SolidCircleUserIcon,
    regularSvg: Regular.RegularCircleUserIcon
  },
  "log-out": {
    name: "arrow-right-from-bracket",
    solidSvg: Solid.SolidArrowRightFromBracketIcon,
    regularSvg: Regular.RegularArrowRightFromBracketIcon
  },
  "file-circle-check": {
    name: "file-circle-check",
    solidSvg: Solid.SolidMemoCircleCheckIcon,
    regularSvg: Regular.RegularMemoCircleCheckIcon
  },
  "circle-question": {
    name: "circle-question",
    solidSvg: Solid.SolidCircleQuestionIcon,
    regularSvg: Regular.RegularCircleQuestionIcon
  },
  "chevron-up": {
    name: "chevron-up",
    solidSvg: Solid.SolidChevronUpIcon,
    regularSvg: Regular.RegularChevronUpIcon
  },
  "chevron-down": {
    name: "chevron-down",
    solidSvg: Solid.SolidChevronDownIcon,
    regularSvg: Regular.RegularChevronDownIcon
  },
  "chevron-left": {
    name: "chevron-left",
    solidSvg: Solid.SolidChevronLeftIcon,
    regularSvg: Regular.RegularChevronLeftIcon
  },
  "chevron-right": {
    name: "chevron-right",
    solidSvg: Solid.SolidChevronRightIcon,
    regularSvg: Regular.RegularChevronRightIcon
  },
  times: {
    name: "xmark",
    solidSvg: Solid.SolidXMarkIcon,
    regularSvg: Solid.SolidXMarkIcon
  },
  "times-circle": {
    name: "circle-xmark",
    solidSvg: Solid.SolidCircleXMarkIcon,
    regularSvg: Solid.SolidCircleXMarkIcon
  },
  verified: {
    name: "verified",
    solidSvg: Solid.SolidBadgeCheckIcon,
    regularSvg: Solid.SolidBadgeCheckIcon
  },
  "check-circle": {
    name: "check-circle",
    solidSvg: Solid.SolidCircleCheckIcon,
    regularSvg: Regular.RegularCircleCheckIcon
  },
  "alert-circle": {
    name: "alert-circle",
    solidSvg: Solid.SolidCircleExclamationIcon,
    regularSvg: Regular.RegularCircleExclamationIcon
  },
  clock: {
    name: "clock",
    solidSvg: Solid.SolidClockIcon,
    regularSvg: Regular.RegularClockIcon
  },
  "magnifying-glass-chart": {
    name: "magnifying-glass-chart",
    solidSvg: Solid.SolidMagnifyingGlassChartIcon,
    regularSvg: Regular.RegularMagnifyingGlassChartIcon
  },
  "location-dot": {
    name: "location-dot",
    solidSvg: Solid.SolidLocationDotIcon,
    regularSvg: Solid.SolidLocationDotIcon
  },
  "caret-up": {
    name: "caret-up",
    solidSvg: Solid.SolidCaretUpIcon,
    regularSvg: Solid.SolidCaretUpIcon
  },
  "caret-down": {
    name: "caret-down",
    solidSvg: Solid.SolidCaretDownIcon,
    regularSvg: Solid.SolidCaretDownIcon
  },
  headset: {
    name: "headset",
    solidSvg: Solid.SolidHeadsetIcon,
    regularSvg: Solid.SolidHeadsetIcon
  },
  "shield-keyhole": {
    name: "shield-keyhole",
    solidSvg: Solid.SolidShieldKeyholeIcon,
    regularSvg: Regular.RegularShieldKeyholeIcon
  },
  "cart-shopping": {
    name: "cart-shopping",
    solidSvg: Solid.SolidCartShoppingIcon,
    regularSvg: Solid.SolidCartShoppingIcon
  },
  "credit-card": {
    name: "credit-card",
    solidSvg: Solid.SolidCreditCardIcon,
    regularSvg: Regular.RegularCreditCardIcon
  },
  star: {
    name: "star",
    solidSvg: Regular.RegularStarIcon,
    regularSvg: Regular.RegularStarIcon
  },
  filter: {
    name: "filter",
    solidSvg: Solid.SolidFilterIcon,
    regularSvg: Regular.RegularFilterIcon
  },
  refresh: {
    name: "refresh",
    solidSvg: Regular.RegularRefreshIcon,
    regularSvg: Regular.RegularRefreshIcon
  },
  "ellipsis-vertical": {
    name: "ellipsis-vertical",
    solidSvg: Regular.RegularEllipsisVerticalIcon,
    regularSvg: Regular.RegularEllipsisVerticalIcon
  },
  eye: {
    name: "eye",
    solidSvg: Solid.SolidEyeIcon,
    regularSvg: Solid.SolidEyeIcon
  },
  "pen-square": {
    name: "pen-square",
    solidSvg: Solid.SolidPenSquareIcon,
    regularSvg: Regular.RegularPenSquareIcon
  },
  "dollar-magnifying-glass": {
    name: "dollar-magnifying-glass",
    solidSvg: Solid.SolidSollarMagnifyingGlassIcon,
    regularSvg: Solid.SolidSollarMagnifyingGlassIcon
  },
  "circle-minus": {
    name: "circle-minus",
    solidSvg: Solid.SolidCircusMinusIcon,
    regularSvg: Solid.SolidCircusMinusIcon
  },
  check: {
    name: "check",
    solidSvg: Solid.SolidCheckIcon,
    regularSvg: Solid.SolidCheckIcon
  },
  "arrow-left": {
    name: "arrow-left",
    solidSvg: Solid.SolidArrowLeftIcon,
    regularSvg: Solid.SolidArrowLeftIcon
  },
  key: {
    name: "key",
    solidSvg: Solid.SolidKeyIcon,
    regularSvg: Solid.SolidKeyIcon
  },
  phone: {
    name: "phone",
    solidSvg: Solid.SolidPhoneIcon,
    regularSvg: Solid.SolidPhoneIcon
  },
  chat: {
    name: "chat",
    solidSvg: Solid.SolidChatIcon,
    regularSvg: Solid.SolidChatIcon
  },
  whatsapp: {
    name: "whatsapp",
    solidSvg: Solid.SolidWhatsAppIcon,
    regularSvg: Solid.SolidWhatsAppIcon
  },
  "file-invoice-dollar": {
    name: "file-invoice-dollar",
    solidSvg: Regular.RegularFileInvoiceDollarIcon,
    regularSvg: Regular.RegularFileInvoiceDollarIcon
  },
  tag: {
    name: "tag",
    solidSvg: Solid.SolidTagIcon,
    regularSvg: Regular.RegularTagIcon
  },
  "bars-progress": {
    name: "bars-progress",
    solidSvg: Regular.RegularBarProgressIcon,
    regularSvg: Regular.RegularBarProgressIcon
  },
  calendars: {
    name: "calendars",
    solidSvg: Regular.RegularCalendarsIcon,
    regularSvg: Regular.RegularCalendarsIcon
  },
  "clipboard-check": {
    name: "clipboard",
    solidSvg: Regular.RegularClipboardCheckIcon,
    regularSvg: Regular.RegularClipboardCheckIcon
  },
  receipt: {
    name: "receipt",
    solidSvg: Solid.SolidReceiptIcon,
    regularSvg: Regular.RegularReceiptIcon
  },
  "circle-xmark": {
    name: "circle-xmark",
    solidSvg: Solid.SolidCircleXMarkIcon,
    regularSvg: Regular.RegularCircleXMark
  },
  "sack-dollar": {
    name: "sack-dollar",
    solidSvg: Solid.SolidSackDollarIcon,
    regularSvg: Solid.SolidSackDollarIcon
  },
  wallet: {
    name: "wallet",
    solidSvg: Solid.SolidWalletIcon,
    regularSvg: Solid.SolidWalletIcon
  },
  calendar: {
    name: "calendar",
    solidSvg: Regular.RegularCalendarIcon,
    regularSvg: Regular.RegularCalendarIcon
  },
  list: {
    name: "list",
    solidSvg: Regular.RegularListIcon,
    regularSvg: Regular.RegularListIcon
  },
  "circle-arrow-down": {
    name: "circle-arrow-down",
    solidSvg: Solid.SolidCircleArrowDownIcon,
    regularSvg: Solid.SolidCircleArrowDownIcon
  },
  "circle-arrow-up": {
    name: "circle-arrow-up",
    solidSvg: Solid.SolidCircleArrowUpIcon,
    regularSvg: Solid.SolidCircleArrowUpIcon
  },
  share: {
    name: "share",
    solidSvg: Regular.RegularShareIcon,
    regularSvg: Regular.RegularShareIcon
  },
  minus: {
    name: "minus",
    solidSvg: Regular.RegularMinusIcon,
    regularSvg: Regular.RegularMinusIcon
  },
  plus: {
    name: "plus",
    solidSvg: Regular.RegularPlusIcon,
    regularSvg: Regular.RegularPlusIcon
  },
  lock: {
    name: "lock",
    solidSvg: Solid.SolidLockIcon,
    regularSvg: Solid.SolidLockIcon
  },
  "share-up": {
    name: "share-up",
    solidSvg: Solid.SolidShareUpIcon,
    regularSvg: Solid.SolidShareUpIcon
  },
  sms: {
    name: "sms",
    solidSvg: Solid.SolidSMSIcon,
    regularSvg: Solid.SolidSMSIcon
  },
  "arrow-down-line": {
    name: "arrow-down-line",
    solidSvg: Regular.RegularArrowDownLineIcon,
    regularSvg: Regular.RegularArrowDownLineIcon
  },
  file: {
    name: "file",
    solidSvg: Regular.RegularFileIcon,
    regularSvg: Regular.RegularFileIcon
  },
  "id-card": {
    name: "id-card",
    solidSvg: Regular.RegularIdCardIcon,
    regularSvg: Regular.RegularIdCardIcon
  },
  "image-portrait": {
    name: "image-portrait",
    solidSvg: Regular.RegularImagePortraitIcon,
    regularSvg: Regular.RegularImagePortraitIcon
  },
  "paperclip-vertical": {
    name: "paperclip-vertical",
    solidSvg: Regular.RegularPaperClipVerticalIcon,
    regularSvg: Regular.RegularPaperClipVerticalIcon
  },
  shop: {
    name: "shop",
    solidSvg: Solid.SolidShopIcon,
    regularSvg: Solid.SolidShopIcon
  },
  qrcode: {
    name: "qrcode",
    solidSvg: Solid.SolidQRCodeIcon,
    regularSvg: Solid.SolidQRCodeIcon
  },
  pen: {
    name: "pen",
    solidSvg: Solid.SolidPenIcon,
    regularSvg: Solid.SolidPenIcon
  },
  gift: {
    name: "gift",
    solidSvg: Solid.SolidGiftIcon,
    regularSvg: Solid.SolidGiftIcon
  },
  trash: {
    name: "trash",
    solidSvg: Regular.RegularTrashIcon,
    regularSvg: Regular.RegularTrashIcon
  },
  camera: {
    name: "camera",
    solidSvg: Solid.SolidCameraIcon,
    regularSvg: Solid.SolidCameraIcon
  },
  "arrow-up-right-from-square": {
    name: "arrow-up-right-from-square",
    solidSvg: Regular.RegularArrowUpRightFromSquareIcon,
    regularSvg: Regular.RegularArrowUpRightFromSquareIcon
  },
  "file-export": {
    name: "file-export",
    solidSvg: Regular.RegularFileExportIcon,
    regularSvg: Regular.RegularFileExportIcon
  }
};
